export default {"src":"/_next/static/media/crosshatch-active.5371f1db.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};